<script setup lang="ts">
import { computed } from 'vue'

const props = withDefaults(
  defineProps<{
    completed: number
    total: number
  }>(),
  {
    completed: 0,
    total: 0,
  },
)

const percent = computed(() => {
  const total = props.total
  if (total <= 0) return 0
  const raw = Math.round((props.completed / total) * 100)
  return Math.min(100, Math.max(0, raw))
})
</script>

<template>
  <div class="relative w-full overflow-visible">
    <span
      class="absolute bottom-full right-0 mb-0.5 text-title-xsm4 font-medium leading-none text-gray">
      {{ percent }}%
    </span>
    <div class="h-3 w-full overflow-hidden bg-stroke">
      <div
        class="box-border block h-full max-w-full bg-darkGreen transition-[width] duration-300"
        :style="{ width: `${percent}%` }"
        role="progressbar"
        :aria-valuenow="percent"
        aria-valuemin="0"
        aria-valuemax="100" />
    </div>
  </div>
</template>
